require("@rails/ujs")

import Rails from '@rails/ujs';
Rails.start();

require("turbolinks").start()
require("@rails/activestorage").start()
require("channels");
require("i18n-iso-countries");
require("pinch-zoom-js");
require("tinygesture");

countries.registerLocale(require("../src/javascripts/i18n-iso-countries/langs/en.json"));
countries.registerLocale(require("../src/javascripts/i18n-iso-countries/langs/de.json"));
countries.registerLocale(require("../src/javascripts/i18n-iso-countries/langs/fr.json"));
countries.registerLocale(require("../src/javascripts/i18n-iso-countries/langs/it.json"));
countries.registerLocale(require("../src/javascripts/i18n-iso-countries/langs/es.json"));

import "../src/javascripts/i18n.js";

const images = require.context('../images', true)
//const imagePath = (name) => images(name, true)

import countries from 'i18n-iso-countries';

import "controllers"

import Modal from "../src/javascripts/modal.js";
import * as main from "../src/javascripts/main.js";

import bulmaCarousel from "bulma-carousel/dist/js/bulma-carousel.min.js";

window.Rails = Rails;
window.countries = countries;
window.main = main;
window.I18n = I18n;
window.Modal = Modal;
window.bulmaCarousel = bulmaCarousel;
